import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import Helper from "../plugins/Helper/Helper"
export class ExportMango {
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportMango(data, type, startDate, endDate) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet('My sheet')
    worksheet.columns = [
      {
        header: "Voucher no.",
        key: 1,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Voucher date",
        key: 2,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Book",
        key: 3,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Ref No.: (Header)",
        key: 4,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Ref. Date (Header)",
        key: 5,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Remark 1",
        key: 6,
        width: 30,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Remark 2",
        key: 7,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "PU Cost Y/N",
        key: 8,
        width: 13,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Account Code in MANGO",
        key: 9,
        width: 30,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "AC Type GL=Normal RV= Reverse",
        key: 10,
        width: 30,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "***Project Code/Site ID",
        key: 11,
        width: 30,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "***Job  Code",
        key: 12,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "***Department Code",
        key: 13,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Cost Code",
        key: 14,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Description",
        key: 15,
        width: 25,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Ref. no. (Detail)",
        key: 16,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Ref Date (Detail)",
        key: 17,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Dr.",
        key: 18,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Cr.",
        key: 19,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Vender Code",
        key: 20,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Customer Code",
        key: 21,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Tax",
        key: 22,
        width: 40,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Tax No",
        key: 23,
        width: 10,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Tax/WT Date",
        key: 24,
        width: 10,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Tax Description",
        key: 25,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Amount",
        key: 26,
        width: 10,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Tax %",
        key: 27,
        width: 10,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Tax Amount",
        key: 28,
        width: 10,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Tax Type",
        key: 29,
        width: 40,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Tax/Personal ID",
        key: 30,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Vendor / Customer Name",
        key: 31,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Branch no",
        key: 32,
        width: 10,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Address 1",
        key: 33,
        width: 10,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Address 2",
        key: 34,
        width: 10,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "W/T No",
        key: 35,
        width: 10,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Option pay & Receipt",
        key: 36,
        width: 35,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Data Type",
        key: 37,
        width: 10,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "",
        key: 38,
        width: 2,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Customer Name",
        key: 39,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Address",
        key: 40,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Address2",
        key: 41,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Address3",
        key: 42,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Tel No.",
        key: 43,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Fax No.",
        key: 44,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Contract",
        key: 45,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Cr Term",
        key: 46,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Maximum Amount",
        key: 47,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "A/C AR",
        key: 48,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "TAX ID",
        key: 49,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "CARD ID",
        key: 50,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "E.Mail",
        key: 51,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Old Code",
        key: 52,
        width: 15,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "A/R Retention",
        key: 53,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Type Debtor",
        key: 54,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
      {
        header: "Branch No.",
        key: 55,
        width: 20,
        style: {
          alignment: {
            vertical: "middle"
          },
          font: { size: 14 }
        }
      },
    ]

    worksheet.spliceRows(1, 0, {
      2: "ช่องสีเทาแมงโก้กรอก",
    })
    worksheet.spliceRows(2, 0, {
      2: "ช่องสีฟ้าให้กรอกข้อมูล (ถ้ามี)",
    })
    worksheet.spliceRows(3, 0, {
      2: "สีส้มต้องกรอกข้อมูล",
    })

    worksheet.spliceRows(4, 0, {
      11: "ระบุรหัสโครงการ/แผนก อย่างใดอย่างหนึ่ง",
      14: "ระบุตาม Master Cost Code",
      15: "หมายเหตุรายบรรทัด",
      18: "ไม่ต้องระบุเครื่องหมาย (+,-)",
      20: "ระบุ Code ตาม Master Vendor",
      21: "ระบุ Code ตาม Master Customer",
      22: "W/T (Paid) = 1, VAT (BUY) = 2,  W/T (Revenue) = 3, VAT (Sale) = 4,   None = N",
      25: "AP >Other > Set up TAX > TAX Code",
      29: "PND. 2 = 2  ภงด. 3 = 3  ภงด.53 = 5  ภงด.54 = 4  ภงด. 1 = A",
      36: `บันทึกข้อมูลตาม Master "Option Pay & Receipt" sheet.`
    })

    worksheet.spliceRows(5, 0, {
      11: "ถ้าระบุโครงการต้องระบุ JOB ของโครงการนั้นเสมอ",
    })

    worksheet.spliceRows(6, 0, {
      1: "แมงโก้กรอก",
      2: "แมงโก้กรอก",
      3: "แมงโก้กรอก",
      4: "(ถ้ามี)",
      5: "(ถ้ามี)",
      6: "ต้องกรอก",
      7: "(ถ้ามี)",
      8: "แมงโก้กรอก",
      9: "ต้องกรอก",
      10: "แมงโก้กรอก",
      11: "ต้องกรอก",
      12: "ต้องกรอก",
      13: "ต้องกรอก",
      14: "ต้องกรอก",
      15: "(ถ้ามี)",
      16: "(ถ้ามี)",
      17: "(ถ้ามี)",
      18: "ต้องกรอก",
      19: "ต้องกรอก",
      20: "(ถ้ามี)",
      21: "(ถ้ามี)",
      22: "(ถ้ามี)",
      23: "(ถ้ามี)",
      24: "(ถ้ามี)",
      25: "(ถ้ามี)",
      26: "(ถ้ามี)",
      27: "(ถ้ามี)",
      28: "(ถ้ามี)",
      29: "(ถ้ามี)",
      30: "(ถ้ามี)",
      31: "(ถ้ามี)",
      32: "(ถ้ามี)",
      33: "(ถ้ามี)",
      34: "(ถ้ามี)",
      35: "(ถ้ามี)",
      36: "(ถ้ามี)",
      37: "แมงโก้กรอก",
      39: "รายการ Customize เพิ่ม สำหรับกรอกข้อมูลลูกค้า",
    })

    worksheet.mergeCells('K4:M4')
    worksheet.mergeCells('R4:S4')
    worksheet.mergeCells('K5:L5')
    worksheet.mergeCells('AM6:BC6')

    worksheet.getRow(4).font = {
      size: 14,
      color: {
        argb: "00F44336"
      },
      bold: true
    };
    worksheet.getRow(4).alignment = {
      horizontal: "center",
      vertical: "middle"
    }

    worksheet.getRow(5).font = {
      size: 14,
      color: {
        argb: "00F44336"
      },
      bold: true
    };
    worksheet.getRow(5).alignment = {
      horizontal: "center",
      vertical: "middle"
    }

    worksheet.getRow(6).font = {
      size: 14,
      color: {
        argb: "00F44336"
      },
      bold: true
    };
    worksheet.getRow(6).alignment = {
      horizontal: "center",
      vertical: "middle"
    }
    worksheet.getRow(6).border = borderStyle()

    worksheet.getRow(7).font = {
      size: 14,
      color: {
        argb: "00FFFFFF"
      },
      bold: true
    };
    worksheet.getRow(7).alignment = {
      horizontal: "center",
      vertical: "middle"
    }
    worksheet.getRow(7).border = borderStyle()
    worksheet.getRow(7).height = 30

    // setcellStyle()?
    let cellBorder = [
      "K4", "N4", "O4", "R4", "T4", "U4", "V4", "Y4", "AC4", "AJ4",
      "K5", "N5", "O5", "R5", "T5", "U5", "V5", "Y5", "AC5", "AJ5",
    ]
    for (let cell of cellBorder) {
      worksheet.getCell(cell).border = borderStyle()
    }

    worksheet.getCell("A1").fill = bgColor("00ADADAD");
    worksheet.getCell("A2").fill = bgColor("009DC3E6");
    worksheet.getCell("A3").fill = bgColor("00DF8344");

    worksheet.getCell("A7").fill = bgColor("00ADADAD");
    worksheet.getCell("B7").fill = bgColor("00ADADAD");
    worksheet.getCell("C7").fill = bgColor("00ADADAD");
    worksheet.getCell("D7").fill = bgColor("009DC3E6");
    worksheet.getCell("E7").fill = bgColor("009DC3E6");
    worksheet.getCell("F7").fill = bgColor("00DF8344");
    worksheet.getCell("G7").fill = bgColor("00DF8344");
    worksheet.getCell("H7").fill = bgColor("00ADADAD");
    worksheet.getCell("I7").fill = bgColor("00DF8344");
    worksheet.getCell("J7").fill = bgColor("00ADADAD");
    worksheet.getCell("K7").fill = bgColor("00DF8344");
    worksheet.getCell("L7").fill = bgColor("00DF8344");
    worksheet.getCell("M7").fill = bgColor("00DF8344");
    worksheet.getCell("N7").fill = bgColor("00DF8344");
    worksheet.getCell("O7").fill = bgColor("009DC3E6");
    worksheet.getCell("P7").fill = bgColor("009DC3E6");
    worksheet.getCell("Q7").fill = bgColor("009DC3E6");
    worksheet.getCell("R7").fill = bgColor("00DF8344");
    worksheet.getCell("S7").fill = bgColor("00DF8344");
    worksheet.getCell("T7").fill = bgColor("009DC3E6");
    worksheet.getCell("U7").fill = bgColor("009DC3E6");
    worksheet.getCell("V7").fill = bgColor("009DC3E6");
    worksheet.getCell("W7").fill = bgColor("009DC3E6");
    worksheet.getCell("X7").fill = bgColor("009DC3E6");
    worksheet.getCell("Y7").fill = bgColor("009DC3E6");
    worksheet.getCell("Z7").fill = bgColor("009DC3E6");
    worksheet.getCell("AA7").fill = bgColor("009DC3E6");
    worksheet.getCell("AB7").fill = bgColor("009DC3E6");
    worksheet.getCell("AC7").fill = bgColor("009DC3E6");
    worksheet.getCell("AD7").fill = bgColor("009DC3E6");
    worksheet.getCell("AE7").fill = bgColor("009DC3E6");
    worksheet.getCell("AF7").fill = bgColor("009DC3E6");
    worksheet.getCell("AG7").fill = bgColor("009DC3E6");
    worksheet.getCell("AH7").fill = bgColor("009DC3E6");
    worksheet.getCell("AI7").fill = bgColor("009DC3E6");
    worksheet.getCell("AJ7").fill = bgColor("009DC3E6");
    worksheet.getCell("AK7").fill = bgColor("00ADADAD");
    worksheet.getCell("AM7").fill = bgColor("009DC3E6");
    worksheet.getCell("AN7").fill = bgColor("009DC3E6");
    worksheet.getCell("AO7").fill = bgColor("009DC3E6");
    worksheet.getCell("AP7").fill = bgColor("009DC3E6");
    worksheet.getCell("AQ7").fill = bgColor("009DC3E6");
    worksheet.getCell("AR7").fill = bgColor("009DC3E6");
    worksheet.getCell("AS7").fill = bgColor("009DC3E6");
    worksheet.getCell("AT7").fill = bgColor("009DC3E6");
    worksheet.getCell("AU7").fill = bgColor("009DC3E6");
    worksheet.getCell("AV7").fill = bgColor("009DC3E6");
    worksheet.getCell("AW7").fill = bgColor("009DC3E6");
    worksheet.getCell("AX7").fill = bgColor("009DC3E6");
    worksheet.getCell("AY7").fill = bgColor("009DC3E6");
    worksheet.getCell("AZ7").fill = bgColor("009DC3E6");
    worksheet.getCell("BA7").fill = bgColor("009DC3E6");
    worksheet.getCell("BB7").fill = bgColor("009DC3E6");
    worksheet.getCell("BC7").fill = bgColor("009DC3E6");

    function bgColor(color) {
      return {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: color
        }
      }
    }
    
    function borderStyle() {
      return {
        top: { style:'thin' },
        left: { style:'thin' },
        bottom: { style:'thin' },
        right: { style:'thin' }
      }
    }

    let index = 0;
    for (let document of data) {
      let items = document.items || []
      let contract = document.contract
      let booking = document.booking
      let customer
      if (contract && contract.customer) {
        customer = contract.customer
      }
      if (booking && booking.customer) {
        customer = booking.customer
      }
      let mangoDocumentId = (document.documentId).substring(0, 10) + (document.documentId).substring(11, 14)
      if (type == "invoice") {
        mangoDocumentId = mangoDocumentId.replace("IV", "SP")
      } else {
        mangoDocumentId = mangoDocumentId.replace("RC", "MK")
      }
      let paymentBankAccount = document.paymentBankAccount

      let address = ""
      let address2 = ""
      let address3 = ""

      if (customer.addressStreet) address += customer.addressStreet + " ";
      if (customer.addressSubDistrict) address += customer.addressSubDistrict + " ";
      if (customer.addressDistrict) address += customer.addressDistrict;

      if (customer.addressProvince) address2 += customer.addressProvince;
      if (customer.addressZipcode) address3 += customer.addressZipcode;

      for(let item of items) {
        index++;
        let accountingProduct = item.accountingProduct
        let row = {
          1: mangoDocumentId,
          2: moment(document.date).add(7, 'hours').toDate(),
          3: "06",
          6: type == "invoice" ? "บันทึกตั้งลูกหนี้" : "บันทึกตัดลูกหนี้",
          8: "Y",
          9: "1140102", //acc code,
          10: "GL",
          11: "00202023",
          12: "001",
          15: "REF : " + document.documentId,
          21: customer?.customerId || "",
          37: "2",
          39: getFullName(customer) || "",
          40: address || "",
          41: address2 || "",
          42: address3 || "",
          43: customer?.tels && customer.tels.length ? customer.tels.filter(d => d).join(",") : "",
          49: "",//customer?.citizenId || "",
          51: customer?.emails && customer.emails.length ? customer.emails.filter(d => d).join(",") : "",
        }
        if (type == "invoice") {
          worksheet.addRow({
            ...row,
            18: item.totalValue,
          })
          if (item.totalVatValue) {
            worksheet.addRow({
              ...row,
              9: "2190102",
              19: item.totalVatValue,
            })
          }
          worksheet.addRow({
            ...row,
            9: accountingProduct?.code,
            19: item.totalNonVatValue,
          })
        }
        
        if (type == "receipt") {
          worksheet.addRow({
            ...row,
            9: paymentBankAccount?.erpCode,
            18: Helper.round(item.totalValue - item.totalWhtValue),
            36: "10002",
          })
          if (item.totalWhtValue) {
            worksheet.addRow({
              ...row,
              9: "1182103",
              18: item.totalWhtValue,
            })
          }
          if (item.totalVatValue) {
            worksheet.addRow({
              ...row,
              9: "2190102",
              18: item.totalVatValue,
            })
            worksheet.addRow({
              ...row,
              9: "2190101",
              19: item.totalVatValue,
            })
          }
          worksheet.addRow({
            ...row,
            9: "1140102",
            19: item.totalValue,
          })
        }
      }
    }

    function getFullName(customer){
      let fullName = "";
      if (customer.type == "personal") {
        if (customer.title) fullName += customer.title + " ";
        if (customer.firstName) fullName += customer.firstName + " ";
        if (customer.lastName) fullName += customer.lastName;
      } else if (customer.type == "company") {
        if (customer.companyName) fullName += customer.companyName;
      }
      return fullName;
    }

    return this.saveFile(workbook, `mango-${type}-${moment(startDate).format("DDMMYYYY")}-${moment(endDate).format("DDMMYYYY")}`);
  }
}